import React, { useState } from 'react';
import { FolderKanban, Loader2, MessageSquare, X } from 'lucide-react';

const getChatProjectId = (chat = {}) => chat.projectId || chat.project_id || null;

const ProjectMoveModal = ({
  isOpen,
  chat = null,
  projects = [],
  onClose,
  onMove,
}) => {
  const [movingToProjectId, setMovingToProjectId] = useState(null);
  if (!isOpen || !chat) return null;

  const currentProjectId = getChatProjectId(chat);

  const move = async (projectId) => {
    setMovingToProjectId(projectId || 'none');
    try {
      await onMove?.({ chatId: chat.id, projectId });
      onClose?.();
    } finally {
      setMovingToProjectId(null);
    }
  };

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/45 px-4 backdrop-blur-[2px]">
      <div className="w-full max-w-md overflow-hidden rounded-2xl border theme-border theme-panel-bg shadow-2xl">
        <div className="flex items-center justify-between gap-3 border-b theme-border px-4 py-3">
          <div>
            <div className="font-semibold theme-text-primary">Move Chat</div>
            <div className="max-w-[320px] truncate text-xs theme-text-muted">
              {chat.topic || 'Untitled Chat'}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-lg theme-text-muted hover:bg-[var(--color-sidebar-item-hover)]"
            title="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="max-h-[56vh] overflow-y-auto p-3">
          <button
            type="button"
            onClick={() => move(null)}
            disabled={!currentProjectId || movingToProjectId !== null}
            className={`mb-1 flex w-full items-center gap-3 rounded-xl px-3 py-3 text-left transition-colors theme-sidebar-item ${
              !currentProjectId ? 'active' : ''
            } disabled:cursor-default disabled:opacity-70`}
          >
            <MessageSquare size={18} className="theme-text-muted" />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium theme-text-primary">No workspace</div>
              <div className="text-xs theme-text-muted">Keep this chat only in All chats.</div>
            </div>
            {movingToProjectId === 'none' && <Loader2 size={16} className="animate-spin theme-text-muted" />}
          </button>

          {projects.map((project) => {
            const isCurrent = currentProjectId === project.id;
            return (
              <button
                key={project.id}
                type="button"
                onClick={() => move(project.id)}
                disabled={isCurrent || movingToProjectId !== null}
                className={`mb-1 flex w-full items-center gap-3 rounded-xl px-3 py-3 text-left transition-colors theme-sidebar-item ${
                  isCurrent ? 'active' : ''
                } disabled:cursor-default disabled:opacity-70`}
              >
                <FolderKanban size={18} className="theme-text-muted" />
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-medium theme-text-primary">{project.name}</div>
                  <div className="truncate text-xs theme-text-muted">
                    {project.description || `${project.chatCount || 0} chats`}
                  </div>
                </div>
                {movingToProjectId === project.id && <Loader2 size={16} className="animate-spin theme-text-muted" />}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProjectMoveModal;
